import { FC } from 'react';
import ReserveAreaList from './ReserveAreaList';
import UseReserveAreaList from './UseReserveAreaList';

const AreaListContainer: FC = () => {
  return <ReserveAreaList {...UseReserveAreaList()} />;
};

export default AreaListContainer;
